import { SET_TOTAL_CAMPAIGNS_COUNT } from './actionTypes';

export const setTotalCampaignsCount = totalCampaignsCount => ({
    type: SET_TOTAL_CAMPAIGNS_COUNT,
    payload: totalCampaignsCount,
});
